import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getWorksMaterialConsumptionRateNorms(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		options
	)
}

function _createWorksMaterialConsumptionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].CREATE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
		options
	)
}

function _getWorksMaterialConsumptionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
		options
	)
}

function _patchWorksMaterialConsumptionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].PATCH_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
		options
	)
}

function _putWorksMaterialConsumptionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].PUT_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
		options
	)
}

function _deleteWorksMaterialConsumptionRateNorm(options = {}) {
	return _apiRequestWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,
		ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].DELETE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]: _getWorksMaterialConsumptionRateNorms,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].CREATE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: _createWorksMaterialConsumptionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: _getWorksMaterialConsumptionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].PATCH_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: _patchWorksMaterialConsumptionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].PUT_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: _putWorksMaterialConsumptionRateNorm,
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].DELETE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM]: _deleteWorksMaterialConsumptionRateNorm,
}